import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    email: '',
    phone: '',
    course: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch('https://script.google.com/macros/s/AKfycbxUJ8rkUb8MzA_nNpe92wyHr2NgHodzOSTO4NRCBUNN0Wh7Y3rOyjOs4r_K8OtY8rvt/exec', {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(() => {
      alert('Form submitted successfully!');
      setFormData({
        name: '',
        age: '',
        email: '',
        phone: '',
        course: '',
        message: ''
      });
    }).catch(err => {
      alert('Submission failed.');
      console.error(err);
    });
  };

  return (
    <div className="container mt-5">
      <h2 className="mb-4">🎓 Student Enquiry Form</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Name</label>
          <input className="form-control" name="name" value={formData.name} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label>Age</label>
          <input className="form-control" name="age" type="number" value={formData.age} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label>Email</label>
          <input className="form-control" name="email" type="email" value={formData.email} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label>Phone</label>
          <input className="form-control" name="phone" value={formData.phone} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label>Course Interested</label>
          <select className="form-select" name="course" value={formData.course} onChange={handleChange} required>
            <option value="">--Select--</option>
            <option value="Web Development">Web Development</option>
            <option value="Data Science">Data Science</option>
            <option value="Digital Marketing">Digital Marketing</option>
          </select>
        </div>
        <div className="mb-3">
          <label>Message</label>
          <textarea className="form-control" name="message" value={formData.message} onChange={handleChange} />
        </div>
        <button className="btn btn-primary">Submit</button>
      </form>
    </div>
  );
}

export default App;
